import Vue from 'vue'
import VueGallery from '@one/vue-gallery'

Vue.component('VGallery', VueGallery)
